import { useState, useEffect, useMemo, memo } from 'react';
import { Box, Button, Grid, List, ListItem, ListItemButton, ListItemText, ListSubheader, Paper, Stack, useMediaQuery } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

function not(a, b) {
  	return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
  	return a.filter((value) => b.includes(value));
}

const TransferList = (props) => {
	const [checked, setChecked] 	= useState([]);

	const [left, setLeft] 			= useState([]);
	const [right, setRight] 		= useState([]);

	useEffect(() => {
		setLeft(props.options && props.selectedOptions ? not(props.options.reduce((selected, item) => [...selected, item.id], []), props.selectedOptions) : [])
		setRight(props.selectedOptions ? props.selectedOptions : [] )
	}, [props.options, props.selectedOptions])

	const leftChecked 	= useMemo(() => intersection(checked, left), [checked, left]);
	const rightChecked 	= useMemo(() => intersection(checked, right), [checked, right]);

	const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

	const handleToggle = (value, event) => {
		
		if (event.shiftKey) {
			const currentIndex = checked.indexOf(value);
			const newChecked = [...checked];

			if (currentIndex === -1) {
				newChecked.push(value);
			} else {
				newChecked.splice(currentIndex, 1);
			}

			setChecked(newChecked);
		}
		else {
			setChecked([value]);

		}
	};

	const handleAllRight = () => {
		setRight(right.concat(left));
		setLeft([]);
		if (props.onChange) props.onChange(right.concat(left))
	};

	const handleCheckedRight = () => {
		setRight(right.concat(leftChecked));
		setLeft(not(left, leftChecked));
		setChecked(not(checked, leftChecked));
		if (props.onChange) props.onChange(right.concat(leftChecked))
	};

	const handleCheckedLeft = () => {
		setLeft(left.concat(rightChecked));
		setRight(not(right, rightChecked));
		setChecked(not(checked, rightChecked));
		if (props.onChange) props.onChange(not(right, rightChecked))
	};

	const handleAllLeft = () => {
		setLeft(props.options)
		setRight([]);
		if (props.onChange) props.onChange([])
	};

	const handleDoubleClick = (value, side) => {
		if (side === 'left') {
			setRight(right.concat([value]));
			setLeft(not(left, [value]));
			setChecked(not(checked, [value]));
			if (props.onChange) props.onChange(right.concat([value]))
		}
		else {
			setLeft(left.concat([value]));
			setRight(not(right, [value]));
			setChecked(not(checked, [value]));
			if (props.onChange) props.onChange(not(right, [value]))
		}
	}

	const handleMoveUp = () => {
		let newArray		= [...right]
		const value1 		= rightChecked[0]
		const value1Index 	= right.findIndex(i => i === rightChecked[0])
		const value2		= right[value1Index - 1]

		if ( value1Index > 0 ) {
			newArray.splice(value1Index - 1, 1, value1)
			newArray.splice(value1Index, 1, value2)

			setRight(newArray)
			if (props.onChange) props.onChange(newArray)
		}
	}

	const handleMoveDown = () => {
		let newArray		= [...right]
		const value1 		= rightChecked[0]
		const value1Index 	= right.findIndex(i => i === rightChecked[0])
		const value2		= right[value1Index + 1]

		if ( value1Index < newArray.length - 1 ) {
			newArray.splice(value1Index + 1, 1, value1)
			newArray.splice(value1Index, 1, value2)

			setRight(newArray)
			if (props.onChange) props.onChange(newArray)
		}
	}

	const SourceList = (items, options, side) => {

		if (!items || !options) return 

		let currentCategory
		let sortedOptions = [...options]//.sort( (v1, v2) => v1.category == v2.category ? v1.label > v2.label ? 1 : -1 : v1.category > v2.category ? 1 : -1)

		return (
			<Paper sx={{ width: '100%', height: props.height || 270, overflow: 'auto' }}  elevation={1}>
				<List dense component="div" role="list">
					{sortedOptions && sortedOptions.map( item => {

						// Array de componentes a serem retornados
						let listItems = []

						// Se estiver na lista de campos disponiveis para selecao, renderiza o campo
						if ( items.find(i => i === item.id) ) {
							const labelId 	= `transfer-list-item-${item.id}-label`;

							// Se a categoria for diferente da anterior, adiciona o campo com a categoria dos campos
							if( currentCategory !== item.category) {
								currentCategory = item.category
								listItems.push(<ListSubheader key={item.category}>{item.categoryDescription}</ListSubheader>)
							}

							// Adiciona o compomente com o campo
							listItems.push(
								<ListItem key={item.id}>
									<ListItemButton
										key={item.id}
										role="listitem"
										onClick={(e) => handleToggle(item.id, e)}
										onDoubleClick={() => handleDoubleClick(item.id, side)}
										selected={checked.includes(item.id)}
										>
										<ListItemText id={labelId} primary={item.label} />
									</ListItemButton>
								</ListItem>
							);
						}

						return listItems
					})}		
				</List>
			</Paper>
		)
	};

	const SelectedList = (items, options, side) => {		
		return (
			<Paper sx={{ width: '100%', height: props.height || 270, overflow: 'auto' }} elevation={1}>
				<List dense component="div" role="list">
					{options && items && items.map(item => {
						const option	= options.find(o => o.id === item)
						const labelId 	= `transfer-list-item-${option.id}-label`;

						return (
							<ListItem key={option.id}>
								<ListItemButton
									key={option.id}
									role="listitem"
									onClick={(e) => handleToggle(option.id, e)}
									onDoubleClick={() => handleDoubleClick(option.id, side)}
									selected={checked.includes(option.id)}
									>
									<ListItemText id={labelId} primary={option.label} />
								</ListItemButton>
							</ListItem>
						);
					})}
				</List>
			</Paper>
		)
	};

	return (
		<Box width={props.width || '98%'}>
			<Grid
				container
				spacing={2}
				sx={{ justifyContent: 'center', alignItems: 'center' }}
				>
				<Grid item xs={12} sm={5} height={300}>{SourceList(left, props.options, 'left')}</Grid>
				<Grid item xs={12} sm={1} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
					<Stack direction={isSmallScreen ? "row" : "column"} spacing={1} sx={{ alignItems: 'center', justifyContent: 'center' }}>
					<Button
						sx={{ my: 0.5, minWidth: 40 }}
						variant="contained"
						size="small"
						onClick={handleAllRight}
						disabled={left.length === 0}
						aria-label="move all right"
						>
						{ isSmallScreen ? <KeyboardDoubleArrowDownIcon /> : '≫' }
					</Button>
					<Button
						sx={{ my: 0.5, minWidth: 40 }}
						variant="contained"
						size="small"
						onClick={handleCheckedRight}
						disabled={leftChecked.length === 0}
						aria-label="move selected right"
						>
						{ isSmallScreen ? <KeyboardArrowDownIcon /> : '›' }
					</Button>
					<Button
						sx={{ my: 0.5, minWidth: 40 }}
						variant="contained"
						size="small"
						onClick={handleCheckedLeft}
						disabled={rightChecked.length === 0}
						aria-label="move selected left"
						>
						{ isSmallScreen ? <KeyboardArrowUpIcon /> : '‹' }
					</Button>
					<Button
						sx={{ my: 0.5, minWidth: 40 }}
						variant="contained"
						size="small"
						onClick={handleAllLeft}
						disabled={right.length === 0}
						aria-label="move all left"
						>
						{ isSmallScreen ? <KeyboardDoubleArrowUpIcon /> : '≪' }
					</Button>
					</Stack>
				</Grid>
				<Grid item xs={12} sm={5}>{SelectedList(right, props.options, 'right')}</Grid>
				<Grid item xs={12} sm={1} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
					<Stack direction={isSmallScreen ? "row" : "column"} spacing={1} sx={{ alignItems: 'center', justifyContent: 'center' }}>
					<Button
						sx={{ my: 0.5, minWidth: 40 }}
						variant="contained"
						size="small"
						onClick={handleMoveUp}
						disabled={right.length === 0}
						aria-label="move all left"
						>
						▲
					</Button>
					<Button
						sx={{ my: 0.5, minWidth: 40 }}
						variant="contained"
						size="small"
						onClick={handleMoveDown}
						disabled={right.length === 0}
						aria-label="move all left"
						>
						▼
					</Button>
					</Stack>					
				</Grid>

			</Grid>
		</Box>
	);
}

export default memo(TransferList)